import React, { Fragment } from 'react'
import styled from 'styled-components'
import DesktopNativeAd from '../boxes/DesktopNativeAd'
import type { BoxType as Box } from '../Types'
import { RegularCol, RegularRow } from '../utils/Grid'
import utmLinkGenerator from '../utils/UTMLinkGenerator'
import ArticleListBox from '../boxes/StyledArticleListBox'
import Prannotation from '../utils/Prannotation'

const ArticleList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
`

type LinksSectionProps = {|
  ad: Object,
  boxes: Array<Box>,
  device: string,
  name: string,
  utmParams: {|
    utmContent: string,
    utmMedium: string,
    utmSource: string
  |}
|}

const renderBoxes = (boxes, utmParams) => {
  return boxes.map((box, index) => {
    const {
      featuredType,
      guid,
      link,
      source,
      title
    } = box

    const utmLinkParams = Object.assign({}, utmParams, {
      utmTerm: `position-${index}`,
      utmCampaign: source
    })

    const utmLink = utmLinkGenerator.createLink(link, utmLinkParams)

    return (
      <ArticleListBox
        featuredSize='inline'
        featuredType={featuredType}
        key={guid}
        link={utmLink}
        title={title}
      />
    )
  })
}

export default (props: LinksSectionProps) => {
  const {
    ad,
    boxes,
    device,
    name,
    utmParams
  } = props

  const listBoxes = renderBoxes(boxes, utmParams)

  const renderedBoxes = ad[device]
    ? <Prannotation AdComponent={DesktopNativeAd} device={device} id={`ad-${name}`} sashec={ad}>
      { listBoxes }
    </Prannotation>
    : <Fragment>{ listBoxes }</Fragment>

  return (
    <RegularRow>
      <RegularCol>
        <ArticleList>
          { renderedBoxes }
        </ArticleList>
      </RegularCol>
    </RegularRow>
  )
}
